const emptyContext = Object.assign(() => '', { keys: () => [] });

// Keep this a direct call so Webpack can discover and watch the image directory.
const portraitContext = process.env.NODE_ENV === 'test'
  ? emptyContext
  : require.context('../assets/chat', false, /\.(png|jpe?g|webp|gif|svg)$/i);

export default portraitContext;
